<template>
  <div class="notifications__table-item">
    <p class="notifications__table_td-number fira-sans">
      {{ notificationItem }}
    </p>
    <p class="notifications__table_td-date fira-sans">{{ notificationDate }}</p>
    <div class="notifications__table_td-description" @click="onView">
      <p class="notifications__table_td-description-title">
        {{ notification.title }}
      </p>
      <p class="notifications__table_td-description-subtitle">
        {{ notification.body }}
      </p>
    </div>
    <div class="notifications__table_td-status fira-sans">
      <StatusBadge
        :name="notification.isViewed ? 'Просмотрено' : 'Не просмотрено'"
        :type="notification.isViewed ? 'green' : 'grey'"
      />
    </div>
  </div>
</template>

<script>
  import StatusBadge from '@/common/components/redesigned/StatusBadge.vue';

  export default {
    name: 'NotificationsTableItem',
    components: { StatusBadge },
    emits: ['onView'],
    props: {
      notification: {
        type: Object,
        required: true,
      },
      notificationItem: Number,
    },
    computed: {
      notificationDate() {
        return this.$momentFormat(this.notification.endDate, 'DD.MM.YYYY');
      },
    },
    methods: {
      onView() {
        this.$emit('onView', this.notification);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '../styles/notificationsTable.scss';
</style>
